export const ParkingStatus = () => null;

ParkingStatus.propTypes = {};

ParkingStatus.defaultProps = {};
